import React, { useState } from 'react';
import { useSelector } from "react-redux";
import Select from "react-select";
import client from '../../../lib/feathers';

export default function MoveVintageModal({ 
  onCancelClick, 
  onMoveClick, 
  libationVintage 
}) {
  const user = useSelector((state) => state.auth.user);
  const [selectedLibation, setSelectedLibation] = useState(null);
  const [libations, setLibations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const loadLibations = async (inputValue = "") => {
    try {
      setIsLoading(true);
      const service = client.service(`${user.role}/libation`);
      const query = {
        $limit: 50,
        ...(user.role === 'industry' && { listingId: libationVintage.libation.listingId }), // Limit to current listing for industry users only
        ...(inputValue && {
          name: { $iLike: `%${inputValue}%` }
        })
      };
      
      const response = await service.find({ query });
      const options = response.data
        .filter(libation => libation.id !== libationVintage.libation.id) // Exclude current libation
        .map((libation) => {
          const vintageYears = libation.libationVintages?.map(lv => lv.vintage?.year).filter(Boolean).sort((a, b) => b - a).map(y => y === 9999 ? 'NV' : y).join(', ') || 'No vintages';
          return {
            value: libation.id,
            label: `${libation.name}${libation.varietal?.name ? ` (${libation.varietal.name})` : ''} - ${vintageYears}`,
            libation: libation
          };
        });
      
      setLibations(options);
    } catch (error) {
      console.error("Error loading libations:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (inputValue) => {
    setSearchText(inputValue);
    if (inputValue.length >= 2) {
      loadLibations(inputValue);
    }
  };

  const handleMove = () => {
    if (selectedLibation && onMoveClick) {
      onMoveClick(selectedLibation.libation);
    }
  };

  return (
    <div className="mt-3 sm:mt-5">
      <h3 className="text-lg leading-6 font-medium text-gray-900 text-center" id="modal-headline">
        Move Vintage to Different Libation
      </h3>
      <div className="mt-4">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
          <div className="flex">
            <div className="ml-3">
              <p className="text-sm text-yellow-700">
                <strong>Moving:</strong> {libationVintage?.vintage?.year === 9999 ? 'NV' : libationVintage?.vintage?.year} {libationVintage?.libation?.name}
              </p>
              <p className="text-sm text-yellow-700 mt-1">
                This will move all associated sips and flight entries to the selected libation.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor="libation-search" className="block text-sm font-medium text-gray-700 mb-2">
            Search for target libation
          </label>
          <Select
            id="libation-search"
            options={libations}
            value={selectedLibation}
            onChange={setSelectedLibation}
            onInputChange={handleSearch}
            isLoading={isLoading}
            placeholder="Type to search libations..."
            noOptionsMessage={() => searchText.length < 2 ? "Type at least 2 characters to search" : "No libations found"}
            className="w-full"
          />
        </div>

        <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button 
            type="button" 
            onClick={handleMove}
            disabled={!selectedLibation}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed sm:col-start-2 sm:text-sm"
          >
            Move Vintage
          </button>
          <button 
            type="button" 
            onClick={onCancelClick}
            className="mt-3 w-full inline-flex justify-center rounded-md border border-primary shadow-sm px-4 py-2 bg-white text-base font-medium text-primary hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:col-start-1 sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}